import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};
// Assuming the state structure has a toast object with an array of toasts
const getToastState = state => selectState(state);

export const getToastData = createSelector([getToastState], toastState => toastState.data);
